import React from "react"
import Marquee from "react-fast-marquee"

const TextMarqueeBannerNM = ({
  backgroundColor,
  fontSize,
  style,
  podcastTag,
}) => {
  return (
    <>
      <Marquee
        loop={0}
        className="marquee-banner"
        gradient={false}
        style={{
          backgroundColor: backgroundColor,
          fontSize: fontSize,
          borderTop: style,
          borderBottom: style,
        }}
      >
        <a
          href="https://open.spotify.com/show/3iAJInCaT9OPNtkgtK9DoT?si=2a208da07e934134&nd=1"
          target="_blank"
          rel="noreferrer"
        >
          <p>{podcastTag}</p>
        </a>
        <a
          href="https://open.spotify.com/show/3iAJInCaT9OPNtkgtK9DoT?si=2a208da07e934134&nd=1"
          target="_blank"
          rel="noreferrer"
        >
          <p>{podcastTag}</p>
        </a>
        <a
          href="https://open.spotify.com/show/3iAJInCaT9OPNtkgtK9DoT?si=2a208da07e934134&nd=1"
          target="_blank"
          rel="noreferrer"
        >
          <p>{podcastTag}</p>
        </a>
        <a
          href="https://open.spotify.com/show/3iAJInCaT9OPNtkgtK9DoT?si=2a208da07e934134&nd=1"
          target="_blank"
          rel="noreferrer"
        >
          <p>{podcastTag}</p>
        </a>
        <a
          href="https://open.spotify.com/show/3iAJInCaT9OPNtkgtK9DoT?si=2a208da07e934134&nd=1"
          target="_blank"
          rel="noreferrer"
        >
          <p>{podcastTag}</p>
        </a>
        <a
          href="https://open.spotify.com/show/3iAJInCaT9OPNtkgtK9DoT?si=2a208da07e934134&nd=1"
          target="_blank"
          rel="noreferrer"
        >
          <p>{podcastTag}</p>
        </a>
        <a
          href="https://open.spotify.com/show/3iAJInCaT9OPNtkgtK9DoT?si=2a208da07e934134&nd=1"
          target="_blank"
          rel="noreferrer"
        >
          <p>{podcastTag}</p>
        </a>
        <a
          href="https://open.spotify.com/show/3iAJInCaT9OPNtkgtK9DoT?si=2a208da07e934134&nd=1"
          target="_blank"
          rel="noreferrer"
        >
          <p>{podcastTag}</p>
        </a>
        <a
          href="https://open.spotify.com/show/3iAJInCaT9OPNtkgtK9DoT?si=2a208da07e934134&nd=1"
          target="_blank"
          rel="noreferrer"
        >
          <p>{podcastTag}</p>
        </a>
        <a
          href="https://open.spotify.com/show/3iAJInCaT9OPNtkgtK9DoT?si=2a208da07e934134&nd=1"
          target="_blank"
          rel="noreferrer"
        >
          <p>{podcastTag}</p>
        </a>
        <a
          href="https://open.spotify.com/show/3iAJInCaT9OPNtkgtK9DoT?si=2a208da07e934134&nd=1"
          target="_blank"
          rel="noreferrer"
        >
          <p>{podcastTag}</p>
        </a>
        <a
          href="https://open.spotify.com/show/3iAJInCaT9OPNtkgtK9DoT?si=2a208da07e934134&nd=1"
          target="_blank"
          rel="noreferrer"
        >
          <p>{podcastTag}</p>
        </a>
      </Marquee>
    </>
  )
}

export default TextMarqueeBannerNM
